import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const cmsModule = defineModule({
  name: "cms",
  label: "Content (CMS)",
  requires: ["core", "accounts", "configuration", "audit", "medialib", "products"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "content/pages",
        permission: "cms.view_page",
        page: () => import("./admin/PagesPage"),
      },
      {
        path: "content/pages/new",
        permission: "cms.add_page",
        page: () => import("./admin/PageEditorPage"),
      },
      {
        path: "content/pages/:uid",
        permission: "cms.view_page",
        page: () => import("./admin/PageEditorPage"),
      },
      {
        path: "content/faqs",
        permission: "cms.view_faqcategory",
        page: () => import("./admin/FaqsPage"),
      },
      {
        path: "content/banners",
        permission: "cms.view_banner",
        page: () => import("./admin/BannersPage"),
      },
      {
        path: "content/blog",
        permission: "cms.view_blogpost",
        page: () => import("./admin/BlogPage"),
      },
      {
        path: "content/blog/posts/new",
        permission: "cms.add_blogpost",
        page: () => import("./admin/PostEditorPage"),
      },
      {
        path: "content/blog/posts/:uid",
        permission: "cms.view_blogpost",
        page: () => import("./admin/PostEditorPage"),
      },
    ],
    nav: [
      {
        id: "cms-pages",
        group: "content",
        label: "cms:pages.nav",
        icon: "file",
        to: "/content/pages",
        permission: "cms.view_page",
        order: 2,
      },
      {
        id: "cms-blog",
        group: "content",
        label: "cms:blog.nav",
        icon: "newspaper",
        to: "/content/blog",
        permission: "cms.view_blogpost",
        order: 3,
      },
      {
        id: "cms-banners",
        group: "content",
        label: "cms:banners.nav",
        icon: "megaphone",
        to: "/content/banners",
        permission: "cms.view_banner",
        order: 1,
      },
      {
        id: "cms-faqs",
        group: "content",
        label: "cms:faqs.nav",
        icon: "help",
        to: "/content/faqs",
        permission: "cms.view_faqcategory",
        order: 4,
      },
    ],
  },
});
